export enum PredefinedFilterValue {
	ALL = 'All_Sent',
	POSITIVE = 'Positive_Sent',
	NEGATIVE = 'Neg_Sent',
	NEUTRAL = 'Neutral_Sent',
	MIXED = 'Mixed_ML_Sent'
}
